import React from "react";

import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";

const isHarvard = preprocessorQuery.isHarvard();

const ItemCardListHeader = ({ children }) => {
  return isHarvard ? null : <div className="entityListHeader">{children}</div>;
};

ItemCardListHeader.displayName = "ItemCardListHeader";

ItemCardListHeader.propTypes = {
  children: PropTypeShapes.elementOrArrayOrList
};

export default ItemCardListHeader;
